import { css, keyframes, styled } from 'styled-components';

import { ButtonOrLink } from '#/components/ButtonOrLink/ButtonOrLink';
import {
  detailsBrandBlueWhenOpenVar,
  detailsCalloutGreyWhenOpenVar,
  detailsOneWhenClosedZeroWhenOpenVar,
} from '#/components/Details/detailsCssVariables';
import { colors, cssBreakpoints, spacing, transition } from '#/theme/theme';

const layoutHeaderButtonBlueVariantCss = css`
  color: ${colors.white};
  background: ${colors.brandBlue};
  outline-color: ${colors.hoverBlue};

  &:hover {
    color: ${colors.white};
    background: ${colors.hoverBlue};
  }
`;

const layoutHeaderDropdownTriggerGreyVariantCss = css`
  color: var(${detailsBrandBlueWhenOpenVar}, ${colors.darkContentGrey});
  background: var(${detailsCalloutGreyWhenOpenVar});

  &:hover {
    background: ${colors.selectionGrey};
  }

  &:is(a):hover {
    color: ${colors.brandBlue};
  }
`;

const layoutHeaderDropdownTriggerSecondaryVariantCss = css`
  border: 1px solid ${colors.brandBlue};
  color: ${colors.brandBlue};
  background: var(${detailsCalloutGreyWhenOpenVar});

  &:hover {
    background-color: ${colors.softBlue};
  }

  &:is(a):hover {
    color: ${colors.brandBlue};
  }
`;

const layoutHeaderDropdownTriggerGreenVariantCss = css`
  color: ${colors.white};
  background: ${colors.brandGreen};
`;

const layoutHeaderDropdownTriggerWhiteVariantCss = css`
  color: ${colors.lightContentGrey};
  background: ${colors.white};
`;

const blueGreenAnimation = keyframes`
  0% { background: ${colors.brandBlue}; }
  40% { background: ${colors.brandGreen}; }
  60% { background: ${colors.brandGreen}; }
  100% { background: ${colors.brandBlue}; }
`;

const layoutHeaderDropdownTriggerBlueGreenAnimationVariantCss = css`
  color: ${colors.white};
  background: ${colors.brandBlue};
  animation: ${blueGreenAnimation} 1.5s;
`;

export const StyledLayoutHeaderButton = styled(ButtonOrLink)<{
  $variant:
    | 'blue'
    | 'grey'
    | 'secondary'
    | 'green'
    | 'white'
    | 'blueGreenAnimate';
  $smallHorizontalPadding: boolean;
  $roundBottomWhenOpen: boolean;
  $centerHorizontally: boolean;
}>`
  color: ${colors.white};
  transition: ${transition};
  display: inline-flex;
  align-items: center;
  height: 38px;
  padding: 0
    ${(props) => (props.$smallHorizontalPadding ? spacing[8] : spacing[12])};
  font-size: 15px;
  border-radius: 6px;
  text-decoration: none;
  cursor: pointer;
  user-select: none;

  > * {
    /* Avoid mouseover triggering while when hovering over other elements */
    pointer-events: none;
  }

  &:hover {
    text-decoration: none;
  }

  justify-content: ${(props) =>
    props.$centerHorizontally ? 'center' : 'space-between'};

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    border-radius: 6px 6px
      ${(props) =>
        props.$roundBottomWhenOpen
          ? `calc(var(${detailsOneWhenClosedZeroWhenOpenVar}, 1) * 6px) calc(var(${detailsOneWhenClosedZeroWhenOpenVar}, 1) * 6px)`
          : ''};
  }

  ${(props) => {
    switch (props.$variant) {
      case 'blue':
        return layoutHeaderButtonBlueVariantCss;
      case 'grey':
        return layoutHeaderDropdownTriggerGreyVariantCss;
      case 'secondary':
        return layoutHeaderDropdownTriggerSecondaryVariantCss;
      case 'green':
        return layoutHeaderDropdownTriggerGreenVariantCss;
      case 'white':
        return layoutHeaderDropdownTriggerWhiteVariantCss;
      case 'blueGreenAnimate':
        return layoutHeaderDropdownTriggerBlueGreenAnimationVariantCss;
    }
  }}
`;
